// extracted by mini-css-extract-plugin
export default {"products":"ot-z","card":"pt-z","oosMessaging":"qt-z"};